import React, { useState } from 'react';
import './Header.css';
import { Link } from 'react-router-dom';

function Header() {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div className='header'>
      <div className='header_left'>
        <Link to="/">
          <div className='header_element header_name'>
            Rodrick Lankford
          </div>
        </Link>
      </div>
      <div className='header_center'>
        <Link to="/projects">
          <div className='header_element'>Projects</div>
        </Link>
        <Link to="/skills">
          <div className='header_element'>Skills</div>
        </Link>
      </div>
      <div className='header_right'>
        <button className='dropdown_btn' onClick={() => setDropdownOpen(!dropdownOpen)}>
          Menu &#x25BC;
        </button>
        {dropdownOpen && (
          <div className='dropdown_menu'>
            <a href="https://github.com/Rodrick12123" target="_blank" rel="noopener noreferrer" className='dropdown_item'>GitHub</a>
            <Link to="/contact" className='dropdown_item' onClick={() => setDropdownOpen(false)}>Contact Me</Link>
            <Link to="/blogs" className='dropdown_item' onClick={() => setDropdownOpen(false)}>Blogs</Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
